export const FETCH_ROOMS = 'FETCH_ROOMS';
export const START_GAME = 'START_GAME';
export const END_GAME = 'END_GAME';
export const END_TIME = 'END_TIME';
export const INCREASE_TIME = 'INCREASE_TIME';